module.exports = __webpack_public_path__ + "img/kaiguan.prt.9ec8c947.jpg";